import { render, staticRenderFns } from "./ChatStats.vue?vue&type=template&id=00b7a84a&scoped=true&"
import script from "./ChatStats.vue?vue&type=script&lang=js&"
export * from "./ChatStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7a84a",
  null
  
)

export default component.exports